import { jsx as _jsx } from "react/jsx-runtime";
import { omitThemingProps, styled, useStyleConfig, vui } from '../core';
import { cs, filterUndefined } from '../utils';
export const PBase = styled.pBox `
  transition-duration: fast;
`;
/** Displays a paragraph of text. */
export const P = vui((props, ref) => {
    const { align, casing, children, className, decoration, text, weight, ...rest } = omitThemingProps(props);
    const styles = useStyleConfig('P', props);
    const aliasedProps = filterUndefined({
        fontWeight: weight,
        textAlign: align,
        textDecoration: decoration,
        textTransform: casing
    });
    return (_jsx(PBase, { className: cs('vui-p', className), ref: ref, ...styles, ...aliasedProps, ...rest, children: children ?? text }));
});
P.displayName = 'P';
export default P;
